import script from "./BillingContactUsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingContactUsDialog.vue?vue&type=script&setup=true&lang=js"

import "./BillingContactUsDialog.vue?vue&type=style&index=0&id=cd8ba574&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd8ba574"]])

export default __exports__